// extracted by mini-css-extract-plugin
export default {"agreementPopup":"agreementPopup___bbd2f2053e403ccb","close":"close___c870c19066a6e49e"};